import { TableRow, TableCell, Caption1 } from '@dhl-ui/components'

type Props = {
  message: string
}
export const DataAside = ({ message }: Props) => (
  <TableRow>
    <TableCell colSpan={2}>
      <Caption1>{message}</Caption1>
    </TableCell>
  </TableRow>
)
